
export const PlaceSection = ({data}) => {

    return (<>
    {data.comune &&<>{data.comune} - </>}
    {data.provincia &&<>{data.provincia} - </>}
    {data.regione &&<>{data.regione}</>}
    </>)

}